import { isProduction } from 'common/utils/environment-util';

/**
 * This is the app's name parsed by lambda@Edge
 *  eg, express.grab.com/book
 *
 * It is also used for various webpack/deployment values
 * so its kept pure here (no slashes) with the intention
 * that slashes be added as needed
 */

export const APP_BASE_URL_NAME = 'book';
export const APP_BASE_URL_PATH = `/${APP_BASE_URL_NAME}`;

export const STORAGE_GFB_TOKEN = '__TOKEN__';
export const STORAGE_CITY = '__CITY__';
export const STORAGE_USER_COUNTRY_CODE_PERSONAL = '__COUNTRY_CODE_PERSONAL__';
export const STORAGE_USER_COUNTRY_CODE = '__COUNTRY_CODE__';
export const STORAGE_LOCALE = '__LOCALE__';
export const STORAGE_SELECTED_COMPANY_ID = '__COMPANY_ID__';
export const STORAGE_SELECTED_GROUP_ID = '__GROUP_ID__';
export const STORAGE_GRABID_AUTH_RESPONSES = '__GRAB_ID_TOKEN__';
export const STORAGE_GRABID_USER_INFO = '__GRAB_ID_USER_INFO__';
export const STORAGE_PAX_USE_PERSONAL_PAYMENTS = '__USE_PAX_PAYMENTS__';
export const STORAGE_PAX_NOT_WHITElISTED = '__PAX_NOT_WHITELISTED__';
export const STORAGE_MEX_INFO = '__MEX_INFO__'; // this key will be injected by mex-app

export const STORAGE_LOGIN_REDIRECT = '__LOGIN_REDIRECT__';
export const STORAGE_SHOPIFY_CALLBACK = '__SHOPIFY_CALLBACK__';

export const APP_SIDER = {
  ADMINISTRATION: 'appSider.administration',
  ACTIVITY: 'appSider.activity',
  CREATE_ORDER: 'appSider.createOrder',
  CONTACT_US: 'appSider.contactUs',
};

export const APP_BREADCRUMB = 'appBar.appBreadcrumb';

export const LOGOUT = 'appBar.logout';
export const UPDATE_PASSWORD = 'appBar.updatePassword';

export const HELP_CENTER = {
  VN: 'https://help.grab.com/hc/vi/360000020627',
  MY: 'https://help.grab.com/hc/ms/360000020627',
  TH: 'https://help.grab.com/hc/th/360000020627',
  ID: 'https://help.grab.com/hc/id/360000020627',
  SG: 'https://help.grab.com/hc/en-sg/360000020627',
  KH: 'https://help.grab.com/hc/km-kh/360000020627',
};

export const HELP_CENTER_CANCEL_BOOKING = {
  VN: 'https://help.grab.com/passenger/vi/900003173603',
  MY: 'https://help.grab.com/passenger/ms/900003173603',
  TH: 'https://help.grab.com/passenger/th/900003173603',
  ID: 'https://help.grab.com/passenger/id/900003173603',
  SG: 'https://help.grab.com/passenger/en-sg/900003173603',
  KH: 'https://help.grab.com/passenger/km-kh/900003173603',
};

export const PROD_SIGNUP_LINK = 'https://business.grab.com/signup';
export const STG_SIGNUP_LINK = 'https://enterprise.stg-myteksi.com/signup';
export const STG_LINK_PAX_APP_URL =
  'https://enterprise.stg-myteksi.com/connect_app?redirectUrl=https%3A%2F%2Fexpress.stg-myteksi.com%2Fbook%2F';
export const PRD_LINK_PAX_APP_URL =
  'https://business.grab.com/connect_app?redirectUrl=https%3A%2F%2Fexpress.grab.com%2Fbook%2F';

export const TOOLTIP = {
  ACTION_HISTORY: 'tooltip.actionHistory',
  ACTIVE_DELIVERY_ITEM: 'tooltip.activeDeliveryItem',
  ADMINISTRATION: 'tooltip.administration',
};

export const INVALID_TOKEN_MODAL = {
  ANYONE_LOGGEDIN_CONTENT: 'invalidTokenModal.anyoneLoggedInContent',
  ANYONE_LOGGEDIN_TITLE: 'invalidTokenModal.anyoneLoggedInTitle',
  OK_TEXT: 'invalidTokenModal.okText',
  SESSION_TIMEOUT_CONTENT: 'invalidTokenModal.sessionTimeoutContent',
  SESSION_TIMEOUT_TITLE: 'invalidTokenModal.sessionTimeoutTitle',
};

export const SUPPORTED_LOCALES = ['en', 'id', 'ms', 'th', 'vi'];

export const COUNTRY_SUPPORTED_LOCALES = {
  sg: ['en'],
  my: ['en', 'ms'],
  ph: ['en'],
  id: ['en', 'id'],
  th: ['en', 'th'],
  vn: ['en', 'vi'],
  kh: ['en'],
};

export const LOCALE_LANGUAGE_MAP = {
  en: 'appBar.locale.english',
  id: 'appBar.locale.bahasa',
  ms: 'appBar.locale.malay',
  th: 'appBar.locale.thai',
  vi: 'appBar.locale.vietnamese',
};

export const LOCALE_COUNTRY_MAP = {
  en: 'sg',
  id: 'id',
  ms: 'my',
  th: 'th',
  vi: 'vn',
};

export const COUNTRY_LOCALE_MAP = {
  sg: 'en',
  id: 'id',
  my: 'ms',
  th: 'th',
  ph: 'en',
  vn: 'vi',
  kh: 'km',
};

export const GRAB_ID_LOGIN_METHOD = 'grabId';

export const DEFAULT_CITY_MAPPING_COUNTRY_CODE = {
  VN: 'Ho Chi Minh',
  PH: 'Metro Manila',
  ID: 'Jakarta',
  MY: 'Kuala Lumpur',
  TH: 'Bangkok',
  SG: 'Singapore',
  KH: 'Phnom Penh',
  MM: 'Yangon',
};

export const MAP_TILES_PRD_URL =
  'https://maptiles.grab.com/v1/styles/basic.json';
export const MAP_TILES_STG_URL =
  'https://maptiles.stg-myteksi.com/v1/styles/basic.json';

export const getMapTilesURL = () =>
  isProduction() ? MAP_TILES_PRD_URL : MAP_TILES_STG_URL;

export const WAYBILLS_ORDERS_KEY = 'orders';
export const WAYBILLS_PAGE_READY = 'waybillsReady';

export const CANCEL_REASON_I18N_MAP = {
  4: 'history.feedbackItems.waitedTooLong',
  5: 'history.feedbackItems.driverAskedCancel',
  12: 'history.feedbackItems.others',
  13: 'history.feedbackItems.changedPlans',
  14: 'history.feedbackItems.changeLocation',
  15: 'history.feedbackItems.driverUncontactable',
};

export const SAVED_PLACE_PRESET_I18N_TAGS = {
  HOME_TAG_PRESET: 'v2.savedPlace.home',
  WORK_TAG_PRESET: 'v2.savedPlace.work',
};

export const ID_OTHER_REASON = 12;
export const DEFAULT_RATING = 5;
